import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import { initTheme } from "@/hooks/use-theme";
import "@/index.css";

// Applied before the first paint so there is no flash of the wrong theme.
initTheme();

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
